import { Button, Col, Row, Container, Table } from 'react-bootstrap';
import toast, { Toaster } from "react-hot-toast";
import { useState, useEffect } from 'react';
import '../css/common.css';
import '../css/hover.css'
import React from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useNavigate } from 'react-router-dom';
import { saveForm, deleteForm } from '../store/Slices/formSlice';
import useValidation from '../helpers/validation';
import * as XLSX from 'xlsx';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faUpload, faTrash, faDownload } from '@fortawesome/free-solid-svg-icons';

function Ireland() {

    const dispatch = useDispatch();
    const navigate = useNavigate();
    const userEmail = sessionStorage.getItem('email');

    useEffect(() => {
        const fetchData = async () => {
            if (!userEmail) {
                navigate('/');
                return;
            }
            const form = JSON.parse(localStorage.getItem('form'));

            if (form?.country?.country === 'Ireland') {
                fillForm(form);
            }
        };

        fetchData();
    }, [dispatch, navigate]);

    const { validateInput, validationStates, setValidationStates } = useValidation();

    const [name, setName] = useState();
    const [address, setAddress] = useState();
    const [city, setCity] = useState();
    const [zip, setZip] = useState();
    const [custName, setCustName] = useState();
    const [custAddress, setCustAddress] = useState();
    const [custCity, setCustCity] = useState();
    const [custZip, setCustZip] = useState();
    const [accNum, setAccNum] = useState();

    const [contactNum, setContactNum] = useState();
    const [position, setPosition] = useState();
    const [printName, setPrintName] = useState();
    const [date, setDate] = useState();

    //Function to get today's date in YYYY-MM-DD format
    // const getCurrentDate = () => {
    //     const today = new Date();
    //     const year = today.getFullYear();
    //     const month = (`0${today.getMonth() + 1}`).slice(-2); // Add leading zero to month
    //     const day = (`0${today.getDate()}`).slice(-2); // Add leading zero to day
    //     return `${year}-${month}-${day}`;
    // };

    // Set the date field to the current date when the component mounts
    // useEffect(() => {
    //     setDate(getCurrentDate());
    // }, []);

    //-----------------------------------------------FillForm-------------------------------------------------//

    const fillForm = (form) => {
        document.querySelector('#name').value = form?.country?.donor?.name ?? '';
        document.querySelector('#address').value = form?.country?.donor?.address ?? '';
        document.querySelector('#city').value = form?.country?.donor?.city ?? '';
        document.querySelector('#zip').value = form?.country?.donor?.zip ?? '';
        setName(form?.country?.donor?.name ?? '');
        setAddress(form?.country?.donor?.address ?? '');
        setCity(form?.country?.donor?.city ?? '');
        setZip(form?.country?.donor?.zip ?? '');

        document.querySelector('#custName').value = form?.country?.customer?.custName ?? '';
        document.querySelector('#custAddress').value = form?.country?.customer?.custAddress ?? '';
        document.querySelector('#custCity').value = form?.country?.customer?.custCity ?? '';
        document.querySelector('#custZip').value = form?.country?.customer?.custZip ?? '';
        document.querySelector('#accNum').value = form?.country?.customer?.accNum ?? '';

        setCustName(form?.country?.customer?.custName ?? '');
        setCustAddress(form?.country?.customer?.custAddress ?? '');
        setCustCity(form?.country?.customer?.custCity ?? '');
        setCustZip(form?.country?.customer?.custZip ?? '');
        setAccNum(form?.country?.customer?.accNum ?? '');

        // setTableDataSingle(JSONDATA?.country?.Single_Number ?? '');
        // setTableDataRange(JSONDATA?.country?.Number_Range ?? '');
        setTableDataSingle(form?.country?.Single_Number ?? []);
        setTableDataRange(form?.country?.Number_Range ?? []);


        // setTableData(form?.country?.portedNumbers?.range ?? []);

        // document.querySelector('#name2').value = form?.country?.requestor?.name2 ?? '';
        // document.querySelector('#title').value = form?.country?.requestor?.title ?? '';
        // document.querySelector('#date').value = form?.country?.requestor?.date ?? '';
        // setName2(form?.country?.requestor?.name2 ?? '');

        document.querySelector('#printName').value = form?.country?.requestor?.printName ?? '';
        document.querySelector('#contactNum').value = form?.country?.requestor?.contactNum ?? '';
        document.querySelector('#position').value = form?.country?.requestor?.position ?? '';
        document.querySelector('#date').value = form?.country?.requestor?.date ?? '';
        setPrintName(form?.country?.requestor?.printName ?? '');
        setContactNum(form?.country?.requestor?.contactNum ?? '');
        setPosition(form?.country?.requestor?.position ?? '');
        setDate(form?.country?.requestor?.date ?? '');

    }

    //-----------------------------------------------Hover-------------------------------------------------//

    const [hoveredField, setHoveredField] = useState(null); //hovered field

    const handleMouseEnter = (field) => {
        setHoveredField(field);
    };

    const handleMouseLeave = () => {
        setHoveredField(null);
    };

    //--------------------------------table declaration (Single)--------------------------------------//

    const [tableDataSingle, setTableDataSingle] = useState([{ id: Date.now(), num: '' }]);

    //adding a row
    const addRow_single = () => {
        setTableDataSingle([...tableDataSingle, { id: Date.now(), num: '' }]);
    };

    //removing a row
    const removeRow_single = (id) => {
        setTableDataSingle(tableDataSingle.filter(row => row.id !== id));
    };

    //change handler of table
    const handleChange_tableSingle = (id, key, value) => {
        const updatedData = tableDataSingle.map(row => {
            if (row.id === id) {
                return { ...row, [key]: value };
            }
            return row;
        });
        setTableDataSingle(updatedData);
    };

    //--------------------------------table declaration (Number Range)--------------------------------------//

    const [tableDataRange, setTableDataRange] = useState([{ id: Date.now(), sNumber: '', eNumber: '' }]);

    //adding a row
    const addRow_range = () => {
        setTableDataRange([...tableDataRange, { id: Date.now(), sNumber: '', eNumber: '' }]);
    };

    //removing a row
    const removeRow_range = (id) => {
        setTableDataRange(tableDataRange.filter(row => row.id !== id));
    };

    //change handler of table
    const handleChange_tableRange = (id, key, value) => {
        const updatedData = tableDataRange.map(row => {
            if (row.id === id) {
                return { ...row, [key]: value };
            }
            return row;
        });
        setTableDataRange(updatedData);
    };

    const fileInputRef = React.createRef();  // Create a reference to the file input element
    const [uploadedFileName, setUploadedFileName] = useState('');

    const handleFileUpload = (event) => {
        const file = event.target.files[0];
        if (!file) return;

        // Display the file name
        setUploadedFileName(file.name);

        const reader = new FileReader();
        reader.onload = (e) => {
            const data = new Uint8Array(e.target.result);
            const workbook = XLSX.read(data, { type: 'array' });
            const sheetName = workbook.SheetNames[0];
            const worksheet = workbook.Sheets[sheetName];

            // Read headers from row 5
            const jsonData = XLSX.utils.sheet_to_json(worksheet, { header: 1, range: 4 });
            if (!jsonData.length) {
                toast.error('Uploaded file is empty or has an invalid format.');
                setUploadedFileName('');
                return;
            }

            const fileHeaders = jsonData[0] || [];
            const expectedHeaders = ['Public from', 'Public to', 'Private from', 'Private to', 'Local Country Value'];

            // Check if headers match
            if (!expectedHeaders.every((header, index) => header === fileHeaders[index])) {
                toast.error('Uploaded file does not match the expected format.');
                setUploadedFileName('');
                return;
            }

            // Read actual data from row 6 onwards
            const dataRows = jsonData.slice(1);

            // Extract relevant data for tableDataRange (first two columns: start & end number)
            const formattedDataRange = dataRows.map((row, index) => ({
                id: index + 1,
                sNumber: row[0] ? row[0].toString() : '', // First column (start number)
                eNumber: row[1] ? row[1].toString() : '', // Second column (end number)
            }));

            // Set the table data for number range
            setTableDataRange(formattedDataRange);

            // Trigger validation for each row after setting data (similar to previous logic)
            formattedDataRange.forEach(row => {
                const startValue = row.sNumber;
                const endValue = row.eNumber;

                // Validate rangeStart
                if (startValue !== '' && !/^\d{7,10}$/.test(startValue)) {
                    setValidationStates(prev => ({
                        ...prev,
                        [`startNumber-${row.id}`]: false,
                    }));
                } else {
                    setValidationStates(prev => ({
                        ...prev,
                        [`startNumber-${row.id}`]: true,
                    }));
                }

                // Validate rangeStop
                if (endValue !== '' && !/^\d{7,10}$/.test(endValue)) {
                    setValidationStates(prev => ({
                        ...prev,
                        [`endNumber-${row.id}`]: false,
                    }));
                } else {
                    setValidationStates(prev => ({
                        ...prev,
                        [`endNumber-${row.id}`]: true,
                    }));
                }

                // Check if end range is greater than or equal to start range
                // if (startValue && endValue && parseInt(endValue, 10) < parseInt(startValue, 10)) {
                //     setValidationStates(prev => ({
                //         ...prev,
                //         [`startNumber-${row.id}`]: false,
                //         [`endNumber-${row.id}`]: false,
                //     }));
                // }

            });
        };
        reader.readAsArrayBuffer(file);
    };

    const removeUploadedFile = () => {
        // Clear the uploaded file name state
        setUploadedFileName('');

        // Reset the file input field value to clear the selected file
        fileInputRef.current.value = '';

        // Clear the table data by setting it to an empty array
        setTableDataRange([]);

        // Optionally clear the table data for 'Number Range' table
        setTableDataRange([]);
    };

    const handleDownload = async () => {
        try {
            // Fetch the file (portabilityImportTemplate.xlsx) from the server
            const response = await fetch(`/portabilityImportTemplate.xlsx?t=${new Date().getTime()}`);

            // Check if the response is valid
            if (!response.ok) throw new Error("Network response was not ok");

            // Convert the response to a Blob
            const blob = await response.blob();

            // Create a URL for the Blob to allow it to be downloaded
            const url = window.URL.createObjectURL(blob);

            // Create an anchor tag dynamically and trigger a click to download the file
            const a = document.createElement("a");
            a.href = url;
            a.download = "portabilityImportTemplate.xlsx"; // File name for download
            document.body.appendChild(a);
            a.click(); // Initiate the download
            document.body.removeChild(a); // Clean up by removing the anchor element
        } catch (error) {
            // Catch any error that occurs during the download process
            console.error("Download failed:", error);
        }
    };

    //-------------------------------------------creating Schema----------------------------------------//

    const json = {
        "country": {
            "country": "Ireland",
            "donor": {
                "name": name,
                "address": address,
                "city": city,
                "zip": zip
            },
            "customer": {
                "custName": custName,
                "custAddress": custAddress,
                "custCity": custCity,
                "custZip": custZip,
                "accNum": accNum
            },
            "Single_Number": tableDataSingle,
            "Number_Range": tableDataRange,

            "requestor": {

                "printName": printName,
                "contactNum": contactNum,
                "position": position,
                "date": date
            }
        },
        "email": sessionStorage.getItem('email'),
    };

    const jsonString = JSON.stringify(json);

    //console.log(jsonString);

    //-----------------------------------------sending request---------------------------------------------//

    async function Submit(e) {

        let validationErrors = {};

        if (!name) {
            validationErrors.name = 'please fill in Operator/Service Provider Name';
        }
        if (!address) {
            validationErrors.address = 'please fill in Address';
        }
        if (!city) {
            validationErrors.city = 'please fill in City';
        }
        // if (!zip) {
        //     validationErrors.zip = 'please fill in Zip';
        // }
        if (!custName) {
            validationErrors.custName = 'please fill in Customer Name';
        }
        if (!custAddress) {
            validationErrors.custAddress = 'please fill in Customer Address';
        }
        if (!custCity) {
            validationErrors.custCity = 'please fill in City Name';
        }
        // if (!custZip) {
        //     validationErrors.custZip = 'please fill in Zip Number';
        // }

        if (!accNum) {
            validationErrors.accNum = 'please fill in Account Number';
        }
        if (!printName) {
            validationErrors.printName = 'please fill in Print Name';
        }
        if (!contactNum) {
            validationErrors.contactNum = 'please fill in Contact Number';
        }
        if (!position) {
            validationErrors.position = 'please fill in Position';
        }
        if (!date) {
            validationErrors.date = 'please fill in Date';
        }

        // tableData.forEach((row, index) => {
        //     if (!row.rangeStart) {
        //         validationErrors[`start-${index}`] = `please fill in First number in range for row ${index + 1}`;
        //     }
        //     if (!row.rangeStop) {
        //         validationErrors[`end-${index}`] = `please fill in Last number in range for row ${index + 1}`;
        //     }
        //     if (!row.num) {
        //         validationErrors[`num-${index}`] = `please fill in Billing Telephone Number(BTN) for row ${index + 1}`;
        //     }
        // });
        // if (!name2) {
        //     validationErrors.name2 = "please fill in Name in Requestor's Details";
        // }
        // if (!title) {
        //     validationErrors.title = 'please fill in Title';
        // }
        // if (!date) {
        //     validationErrors.date = 'please fill in Date';
        // }

        const hasValidationError = Object.values(validationErrors).length > 0;

        if (hasValidationError) {
            // Update validation states
            setValidationStates(prevState => ({
                ...prevState,
                ...Object.keys(validationErrors).reduce((acc, key) => {
                    acc[key] = false;
                    return acc;
                }, {})
            }));

            //Show the first error message
            const firstError = Object.values(validationErrors)[0];
            const firstErrorKey = Object.keys(validationErrors)[0];
            document.getElementById(firstErrorKey).scrollIntoView({ behavior: "smooth", block: "center", inline: "center" });
            toast.error(firstError);
            return;

        }

        const falseKeys = Object.entries(validationStates)
            .filter(([key, value]) => value === false)
            .map(([key, value]) => key);

        if (falseKeys.length > 0) {
            toast.error(`Please make sure fields in red are correct. \n${falseKeys} `);
            const elem = document.getElementById(falseKeys[0]);
            elem.scrollIntoView({ behavior: "smooth", block: "center", inline: "center" });
            return;
        }
        // If all validations pass, proceed with the form submission
        e.preventDefault();
        try {
            const response = await fetch(`${process.env.REACT_APP_API_URL}/generate_loa`, {
                method: 'POST',
                headers: {
                    "Content-Type": "application/json",
                },
                body: jsonString
            });

            if (!response.ok) {
                throw new Error('Network response was not ok');
            }

            const blobData = await response.blob();
            const url = URL.createObjectURL(blobData);
            const a = document.createElement('a');
            a.href = url;
            a.download = address + '-LOA.docx';
            document.body.appendChild(a);
            a.click();
            document.body.removeChild(a);
            URL.revokeObjectURL(url);

        } catch (error) {
            console.error('Error downloading file: ', error);
            // toast.error("An error occurred while processing your request.");
            window.location.href = 'https://my-service-space.orange-business.com/wacsmss/group/mssportal/home';
        }
    }

    //----------------------------------------------RESET--------------------------------------------------//

    async function Reset(e) {
        const dataToBeDeleted = { "email": userEmail };
        dispatch(deleteForm(dataToBeDeleted));
        localStorage.removeItem('form');
        window.location.reload();
    }

    // async function save(e) {
    //     e.preventDefault();
    //     const falseKeys = Object.entries(validationStates)
    //         .filter(([key, value]) => {
    //             const element = document.getElementById(key);
    //             return value === false && element && element.value.trim() !== '';
    //         })
    //         .map(([key, value]) => key);

    //     if (falseKeys.length > 0) {
    //         const elem = document.getElementById(falseKeys[0]);
    //         elem.scrollIntoView({ behavior: "smooth", block: "center", inline: "center" });
    //         toast.error(`Please make sure following fields in red are correct before saving `);
    //         return;
    //     }

    //     localStorage.setItem('form', JSON.stringify(json));
    //     const dataToBeSaved = { "email": userEmail, "json_data": json };
    //     try {
    //         const response = await dispatch(saveForm(dataToBeSaved));
    //         if (response?.payload?.message === "success") {
    //             toast.success('Form saved successfully');
    //         }
    //     } catch (error) {
    //         // toast.error('There was an error processing your request.');
    //         window.location.href = 'https://businesstalk.sso.infra.ftgroup/btc/index.html#/ng1/home/library/portabilityInTemplates';

    //     }
    // }

    async function save(e) {
        e.preventDefault();
        const falseKeys = Object.entries(validationStates)
            .filter(([key, value]) => {
                const element = document.getElementById(key);
                return value === false && element && element.value.trim() !== '';
            })
            .map(([key, value]) => key);

        if (falseKeys.length > 0) {
            const elem = document.getElementById(falseKeys[0]);
            elem.scrollIntoView({ behavior: "smooth", block: "center", inline: "center" });
            toast.error(`Please make sure following fields in red are correct before saving `);
            return;
        }

        localStorage.setItem('form', JSON.stringify(json));
        const dataToBeSaved = { "email": userEmail, "json_data": json };
        try {
            const response = await dispatch(saveForm(dataToBeSaved));
            if (response?.payload?.message === "success") {
                toast.success('Form saved successfully');
            }
        } catch (error) {
            toast.error('There was an error processing your request.');
        }
    }

    //-----------------------------------------------JSX----------------------------------------------------//

    return (
        <div>

            <Toaster position="top-center" reverseOrder={false}></Toaster>

            <div className='french'>

                <Container>

                    <p><strong>Mandatory fields are marked by *</strong></p>

                    <h2 className='heading'>Donor / Loosing Operator</h2> <br></br>

                    <Row>

                        <Col
                            onMouseEnter={() => handleMouseEnter('name')}
                            onMouseLeave={handleMouseLeave}
                        >
                            <label>Operator Name*</label> <br />
                            <input
                                onChange={(e) => setName(e.target.value)}
                                type="text"
                                id="name"
                                placeholder=""
                                className={`inputbox ${validationStates.name === false ? 'error' : ''}`}
                                onBlur={() => validateInput('name', /^[\w\W,]+$/)}

                            />
                            {hoveredField === 'name' && (
                                <div className="hover-description">
                                    Enter the current service provider (e.g. Vodafone Ireland Ltd)
                                </div>
                            )}
                        </Col>

                        <Col
                            onMouseEnter={() => handleMouseEnter('address')}
                            onMouseLeave={handleMouseLeave}
                        >
                            <label>Address*</label> <br />
                            <input
                                onChange={(e) => setAddress(e.target.value)}
                                type="text"
                                id="address"
                                placeholder=""
                                className={`inputbox ${validationStates.address === false ? 'error' : ''}`}
                                onBlur={() => validateInput('address', /^[\w\W,]+$/)}

                            />
                            {hoveredField === 'address' && (
                                <div className="hover-description">
                                    Enter the current operator address (e.g. Mountview, Leopardstown)
                                </div>
                            )}
                        </Col>

                        <Col
                            onMouseEnter={() => handleMouseEnter('city')}
                            onMouseLeave={handleMouseLeave}
                        >
                            <label>City*</label> <br />
                            <input
                                onChange={(e) => setCity(e.target.value)}
                                type="text"
                                id="city"
                                placeholder=""
                                className={`inputbox ${validationStates.city === false ? 'error' : ''}`}
                                onBlur={() => validateInput('city', /^[\w\W,]+$/)}

                            />
                            {hoveredField === 'city' && (
                                <div className="hover-description">
                                    Enter the current operator city (e.g. Dublin)
                                </div>
                            )}
                        </Col>

                        <Col
                            onMouseEnter={() => handleMouseEnter('zip')}
                            onMouseLeave={handleMouseLeave}
                        >
                            <label>Zip</label> <br />
                            <input
                                onChange={(e) => setZip(e.target.value)}
                                type="text"
                                id="zip"
                                placeholder=""
                                className={`inputbox`}
                            // onBlur={() => validateInput('zip', /^[\w\W,]+$/)}

                            />
                            {hoveredField === 'zip' && (
                                <div className="hover-description">
                                    Enter the current operator zip code if applicable (e.g. D18 XN97)
                                </div>
                            )}
                        </Col>

                    </Row>

                    <br />

                </Container>

                <br></br><br></br>

                <Container>

                    <h2 className='heading'>Customer Details</h2> <br></br>

                    <Row>

                        <Col
                            onMouseEnter={() => handleMouseEnter('custName')}
                            onMouseLeave={handleMouseLeave}
                        >
                            <label>Customer Name*</label> <br />
                            <input
                                onChange={(e) => setCustName(e.target.value)}
                                type="text"
                                id="custName"
                                placeholder=""
                                className={`inputbox ${validationStates.custName === false ? 'error' : ''}`}
                                onBlur={() => validateInput('custName', /^[\w\W,]+$/)}

                            />
                            {hoveredField === 'custName' && (
                                <div className="hover-description">
                                    Enter the current customer name (e.g. Electric Europe B.V)
                                </div>
                            )}
                        </Col>

                        <Col
                            onMouseEnter={() => handleMouseEnter('custAddress')}
                            onMouseLeave={handleMouseLeave}
                        >
                            <label>Address*</label> <br />
                            <input
                                onChange={(e) => setCustAddress(e.target.value)}
                                type="text"
                                id="custAddress"
                                placeholder=""
                                className={`inputbox ${validationStates.custAddress === false ? 'error' : ''}`}
                                onBlur={() => validateInput('custAddress', /^[\w\W,]+$/)}

                            />
                            {hoveredField === 'custAddress' && (
                                <div className="hover-description">
                                    Enter the current address (e.g. Business Park, Ballymount)
                                </div>
                            )}
                        </Col>

                        <Col
                            onMouseEnter={() => handleMouseEnter('custCity')}
                            onMouseLeave={handleMouseLeave}
                        >
                            <label>City*</label> <br />
                            <input
                                onChange={(e) => setCustCity(e.target.value)}
                                type="text"
                                id="custCity"
                                placeholder=""
                                className={`inputbox ${validationStates.custCity === false ? 'error' : ''}`}
                                onBlur={() => validateInput('custCity', /^[\w\W,]+$/)}

                            />
                            {hoveredField === 'custCity' && (
                                <div className="hover-description">
                                    Enter the current city (e.g. Dublin)
                                </div>
                            )}
                        </Col>

                        <Col
                            onMouseEnter={() => handleMouseEnter('custZip')}
                            onMouseLeave={handleMouseLeave}
                        >
                            <label>Zip</label> <br />
                            <input
                                onChange={(e) => setCustZip(e.target.value)}
                                type="text"
                                id="custZip"
                                placeholder=""
                                className={`inputbox`}
                            // onBlur={() => validateInput('custZip', /^[\w\W,]+$/)}

                            />
                            {hoveredField === 'custZip' && (
                                <div className="hover-description">
                                    Enter the current zip code if applicable (e.g. D24 P220)
                                </div>
                            )}
                        </Col>

                        <Row></Row>

                        <br></br>

                        <Row>

                            <Col
                                onMouseEnter={() => handleMouseEnter('accNum')}
                                onMouseLeave={handleMouseLeave}
                            >
                                <label>Customer Account Number at Donor*</label> <br />
                                <input
                                    onChange={(e) => setAccNum(e.target.value)}
                                    type="text"
                                    id="accNum"
                                    placeholder=""
                                    className={`inputbox ${validationStates.accNum === false ? 'error' : ''}`}
                                    onBlur={() => validateInput('accNum', /^[\w\W,]+$/)}

                                />
                                {hoveredField === 'accNum' && (
                                    <div className="hover-description">
                                        Enter the customer account number as shown on most recent telecommunications bill from donor (e.g. 92245618)
                                    </div>
                                )}
                            </Col>

                        </Row>

                    </Row>

                    <br />

                </Container>

                <br></br>

                <Container>
                    <h2 className='heading'>Telephone Number/s</h2> <br></br>
                    <p className='heading'>Numbers entered here should be either GEO or NON GEO, no mix up between the 2 types, otherwise this will result for the LOA to be rejected. Please submit separate documents for each type</p>

                    <h4 className='text-decoration-underline'>Single Number</h4> <br></br>

                    <Table striped bordered hover variant="light">
                        <thead>
                            <tr>
                                <th>Number</th>
                            </tr>
                        </thead>
                        <tbody>

                            {tableDataSingle.map(row => (
                                <tr key={row.id}>

                                    <td
                                        onMouseEnter={() => handleMouseEnter(`number-${row.id}`)}
                                        onMouseLeave={handleMouseLeave}
                                    >
                                        <input
                                            type="text"
                                            id={`number-${row.id}`}
                                            value={row.num}
                                            onChange={(e) => {
                                                const value = e.target.value;

                                                // Update the state with the input value
                                                handleChange_tableSingle(row.id, 'num', value);

                                                // Immediate validation feedback for 7 to 10 digits only when not empty
                                                if (value !== '' && !/^\d{7,10}$/.test(value)) {
                                                    setValidationStates(prev => ({
                                                        ...prev,
                                                        [`number-${row.id}`]: false,
                                                    }));
                                                } else {
                                                    setValidationStates(prev => ({
                                                        ...prev,
                                                        [`number-${row.id}`]: true,
                                                    }));
                                                }
                                            }}
                                            className={`inputbox ${validationStates[`number-${row.id}`] === false && row.num !== '' ? 'error' : ''}`}
                                            onBlur={() => {
                                                // Final validation check on blur for 7 to 10 digits only when not empty
                                                if (row.num !== '' && !/^\d{7,10}$/.test(row.num)) {
                                                    toast.error('Number must be between 7 and 10 digits.');
                                                    setValidationStates(prev => ({
                                                        ...prev,
                                                        [`number-${row.id}`]: false,
                                                    }));
                                                }
                                            }}
                                        />
                                        {hoveredField === `number-${row.id}` && (
                                            <div className="hover-description">
                                                Enter the single number if found to be ported (e.g. 014199800)
                                            </div>
                                        )}
                                        {validationStates[`number-${row.id}`] === false && row.num !== '' && (
                                            <div className="error-message">
                                                Number must be between 7 and 10 digits.
                                            </div>
                                        )}
                                    </td>


                                    <td>
                                        {tableDataSingle.length > 1 && (
                                            <button onClick={() => removeRow_single(row.id)}>Remove</button>
                                        )}
                                    </td>
                                </tr>
                            ))}

                        </tbody>
                    </Table>

                    <button onClick={addRow_single}>Add Row</button>

                    <br />

                </Container>

                <br></br>

                <Container>

                    <h4 className='text-decoration-underline'>Number Range</h4> <br></br>

                    <Row>
                        <Col>
                            <button
                                variant="secondary"
                                className="inputbox"
                                style={{ alignItems: 'center' }}
                                onClick={() => fileInputRef.current.click()}
                            >
                                <FontAwesomeIcon icon={faUpload} style={{ marginRight: '8px' }} />
                                Upload File
                            </button>
                            <input
                                id="fileUploadInput"
                                type="file"
                                accept=".xlsx, .xls"
                                onChange={handleFileUpload}
                                ref={fileInputRef}
                                style={{ display: 'none' }}
                            />
                        </Col>

                        <Col>
                            <button className="inputbox" onClick={handleDownload} style={{ alignItems: 'center' }}>
                                <FontAwesomeIcon icon={faDownload} style={{ marginRight: '8px' }} />
                                Download number range template
                            </button>
                        </Col>

                        <Col>
                            {uploadedFileName && (
                                <button onClick={removeUploadedFile} className="inputbox" style={{ alignItems: 'center' }}>
                                    <FontAwesomeIcon icon={faTrash} style={{ marginRight: '8px' }} />
                                    Remove
                                </button>
                            )}
                        </Col>
                    </Row>

                    <Row>
                        <Col>
                            {uploadedFileName && (
                                <div style={{ display: 'flex', alignItems: 'center', marginTop: '10px' }}>
                                    <p style={{ marginRight: '10px' }}>Uploaded File: {uploadedFileName}</p>
                                </div>
                            )}
                        </Col>
                    </Row>

                    <br />
                    <p>The template is the same used for the btd portability request.</p>
                    <br />

                    <Table striped bordered hover variant="light">
                        <thead>
                            <tr>
                                <th>First number in range</th>
                                <th>Last number in range</th>
                            </tr>
                        </thead>

                        <tbody>

                            {tableDataRange.map(row => (
                                <tr key={row.id}>

                                    <td
                                        onMouseEnter={() => handleMouseEnter(`startNumber-${row.id}`)}
                                        onMouseLeave={handleMouseLeave}
                                    >
                                        <input
                                            type="text"
                                            id={`startNumber-${row.id}`} // Corrected ID for num input
                                            value={row.sNumber}
                                            onChange={(e) => {
                                                const value = e.target.value;

                                                // Update the state with the input value
                                                handleChange_tableRange(row.id, 'sNumber', value);

                                                // Immediate validation feedback for 7 to 10 digits
                                                if (value && !/^\d{7,10}$/.test(value)) { // Allow between 7 and 10 digits
                                                    setValidationStates(prev => ({
                                                        ...prev,
                                                        [`startNumber-${row.id}`]: false,
                                                    }));
                                                } else {
                                                    setValidationStates(prev => ({
                                                        ...prev,
                                                        [`startNumber-${row.id}`]: true,
                                                    }));
                                                }
                                            }}
                                            className={`inputbox ${validationStates[`startNumber-${row.id}`] === false ? 'error' : ''}`}
                                            onBlur={() => {
                                                // Final validation check on blur for 7 to 10 digits
                                                if (row.sNumber && !/^\d{7,10}$/.test(row.sNumber)) { // Only validate if value is not empty
                                                    toast.error('Number must be between 7 and 10 digits.');
                                                    setValidationStates(prev => ({
                                                        ...prev,
                                                        [`startNumber-${row.id}`]: false,
                                                    }));
                                                }
                                            }}
                                        />
                                        {hoveredField === `startNumber-${row.id}` && (
                                            <div className="hover-description">
                                                Enter the start of number range if found to be ported (e.g. 24199800).
                                            </div>
                                        )}
                                        {validationStates[`startNumber-${row.id}`] === false && row.sNumber !== '' && (
                                            <div className="error-message">
                                                Number must be between 7 and 10 digits.
                                            </div>
                                        )}
                                    </td>

                                    <td
                                        onMouseEnter={() => handleMouseEnter(`endNumber-${row.id}`)}
                                        onMouseLeave={handleMouseLeave}
                                    >
                                        <input
                                            type="text"
                                            id={`endNumber-${row.id}`} // Corrected ID for num input
                                            value={row.eNumber}
                                            onChange={(e) => {
                                                const value = e.target.value;

                                                // Update the state with the input value
                                                handleChange_tableRange(row.id, 'eNumber', value);

                                                // Immediate validation feedback for 7 to 10 digits
                                                if (value && !/^\d{7,10}$/.test(value)) { // Allow between 7 and 10 digits
                                                    setValidationStates(prev => ({
                                                        ...prev,
                                                        [`endNumber-${row.id}`]: false,
                                                    }));
                                                } else {
                                                    setValidationStates(prev => ({
                                                        ...prev,
                                                        [`endNumber-${row.id}`]: true,
                                                    }));
                                                }
                                            }}
                                            className={`inputbox ${validationStates[`endNumber-${row.id}`] === false ? 'error' : ''}`}
                                            onBlur={() => {
                                                // Final validation check on blur for 7 to 10 digits
                                                if (row.eNumber && !/^\d{7,10}$/.test(row.eNumber)) { // Only validate if value is not empty
                                                    toast.error('Number must be between 7 and 10 digits.');
                                                    setValidationStates(prev => ({
                                                        ...prev,
                                                        [`endNumber-${row.id}`]: false,
                                                    }));
                                                }
                                            }}
                                        />
                                        {hoveredField === `endNumber-${row.id}` && (
                                            <div className="hover-description">
                                                Enter the end of the number range if found to be ported (e.g. 34199800).
                                            </div>
                                        )}
                                        {validationStates[`endNumber-${row.id}`] === false && row.eNumber !== '' && (
                                            <div className="error-message">
                                                Number must be between 7 and 10 digits.
                                            </div>
                                        )}
                                    </td>

                                    <td>
                                        {tableDataRange.length > 1 && (
                                            <button onClick={() => removeRow_range(row.id)}>Remove</button>
                                        )}
                                    </td>
                                </tr>
                            ))}

                        </tbody>
                    </Table>

                    <button onClick={addRow_range}>Add Row</button>

                    <br />

                </Container>

                <br></br>

                <Container>

                    <h2 className='heading'>Authorized Contact for Porting details</h2> <br></br>

                    <p className='heading'>By signature of this form, I authorise you to close my account in respect of the above telephone number/s in conjunction with the successful porting of those numbers to another operator.

                        I understand that this form will be relayed to you by use of electronic or other means.

                        I confirm that I have the authority to make this instruction.

                        The information contained in this form may not be used for any purpose other than that for which it is intended.
                    </p>

                    <Row>
                        <Col
                            onMouseEnter={() => handleMouseEnter('printName')}
                            onMouseLeave={handleMouseLeave}
                        >
                            <label>Print Name*</label> <br />
                            <input
                                onChange={(e) => setPrintName(e.target.value)}
                                type="text"
                                id="printName"
                                placeholder=""
                                className={`inputbox ${validationStates.printName === false ? 'error' : ''}`}
                                onBlur={() => validateInput('printName', /^[\w\W,]+$/)}

                            />
                            {hoveredField === 'printName' && (
                                <div className="hover-description">
                                    Enter the authorized Contact for Porting
                                </div>
                            )}
                        </Col>

                        <Col
                            onMouseEnter={() => handleMouseEnter('contactNum')}
                            onMouseLeave={handleMouseLeave}
                        >
                            <label>Contact Number*</label> <br />
                            <input
                                onChange={(e) => setContactNum(e.target.value)}
                                type="text"
                                id="contactNum"
                                placeholder=""
                                className={`inputbox ${validationStates.contactNum === false ? 'error' : ''}`}
                                onBlur={() => validateInput('contactNum', /^\d+$/)}

                            />
                            {hoveredField === 'contactNum' && (
                                <div className="hover-description">
                                    Enter the number of authorized Contact for signing the Porting requests
                                </div>
                            )}
                        </Col>

                        <Col
                            onMouseEnter={() => handleMouseEnter('position')}
                            onMouseLeave={handleMouseLeave}
                        >
                            <label>Position*</label> <br />
                            <input
                                onChange={(e) => setPosition(e.target.value)}
                                type="text"
                                id="position"
                                placeholder=""
                                className={`inputbox ${validationStates.position === false ? 'error' : ''}`}
                                onBlur={() => validateInput('position', /^[\w\W,]+$/)}

                            />
                            {hoveredField === 'position' && (
                                <div className="hover-description">
                                    Enter the position of authorized Contact for signing the Porting requests (e.g. Head of IT)
                                </div>
                            )}
                        </Col>

                        <Col>
                            <label>Date*</label> <br />
                            <input
                                onChange={(e) => setDate(e.target.value)}
                                type="date"
                                id="date"
                                value={date} // Automatically set the current date
                                className={`inputbox ${validationStates.date === false ? 'error' : ''}`}
                                onBlur={() => validateInput('date', /^.*$/)}
                                min={new Date(new Date().setDate(new Date().getDate() + 1)).toISOString().split('T')[0]} // Disable today and past dates
                            />
                        </Col>
                    </Row>

                </Container>

                <br></br><br></br>

                <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
                    <Button variant="primary" type="save" onClick={save}>Save</Button>
                    <Button variant="primary" type="submit" onClick={Submit}>Generate LOA</Button>
                    <Button variant="primary" type="reset" onClick={Reset} style={{ marginRight: '20px' }}>Reset</Button>
                </div>
            </div>

        </div>
    );
}

export default Ireland;